// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2LKLO","col":"styles_col__3oaAt"};